import { useMemo } from 'react';
import { useLocale } from './useLocale';
/**
 * Returns a date formatter than can be used to display dates in a locale-aware way.
 */
const useDateFormatter = (options) => {
    const { languageCode } = useLocale();
    const dateFormatter = useMemo(() => new Intl.DateTimeFormat(languageCode, options), [languageCode, options]);
    return dateFormatter;
};
export { useDateFormatter };
//# sourceMappingURL=useDateFormatter.js.map